export const formatNumberWithPrefixSuffix = (
  value: unknown,
  prefix?: string,
  suffix?: string,
) => {
  if (value === null || value === undefined || value === "") return "";
  const num = typeof value === "number" ? value : Number(value);
  if (Number.isNaN(num)) return String(value);
  const isNegative = num < 0;
  const absText = Math.abs(num).toLocaleString();
  const safePrefix = prefix ?? "";
  const safeSuffix = suffix ?? "";
  if (isNegative) {
    return `-${safePrefix}${absText}${safeSuffix}`;
  }
  return `${safePrefix}${absText}${safeSuffix}`;
};
